var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24.231,
    viewBox: "0 0 35 24.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.308,7H5.692A2.692,2.692,0,0,0,3,9.692V28.538a2.692,2.692,0,0,0,2.692,2.692H35.308A2.692,2.692,0,0,0,38,28.538V9.692A2.692,2.692,0,0,0,35.308,7ZM13.769,27.192H8.385a1.346,1.346,0,0,1,0-2.692h5.385a1.346,1.346,0,0,1,0,2.692Zm1.346-9.423a1.346,1.346,0,0,1-1.346,1.346H8.385a1.346,1.346,0,0,1-1.346-1.346V12.385a1.346,1.346,0,0,1,1.346-1.346h5.385a1.346,1.346,0,0,1,1.346,1.346Zm17.5,9.423H21.846a1.346,1.346,0,0,1,0-2.692H32.615a1.346,1.346,0,0,1,0,2.692Z",
    transform: "translate(-3 -7)",
    fill: "#0533b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e187214399acd4cc44f10772f769ad47.svg";
export { ForwardRef as ReactComponent };